
export const Category = ({
  children,
  selected,
  onClick,
}: {
  children: string;
  selected?: boolean;
  onClick: (category: string) => void;
}) => (
  <span className="flex cursor-pointer items-center" onClick={() => onClick(children)}>
    {selected && <div className="mr-1.5 h-2 w-2 rotate-45 bg-neutral-700 xl:mr-6"></div>}
    <span
      className={`whitespace-nowrap text-lg text-neutral-70 transition-colors ${selected && 'text-neutral-700'}`}
    >
      {children}
    </span>
  </span>
);